@if (showUpdateNotification) {
    <div class="update-notification">
        <div class="update-content">
            <div class="update-icon"><i class="ph ph-arrows-clockwise" aria-hidden="true"></i></div>
            <div class="update-text">
                <h4 class="update-heading">
                    {{ 'sw-update-notification-title' | translate }}
                    @if (countdown > 0) {
                        <span class="countdown">({{ countdown }}s)</span>
                    }
                </h4>
                <p>{{ 'sw-update-notification-body' | translate }}</p>
            </div>
            <div class="update-actions">
                <p-button
                    type="button"
                    [label]="'sw-update-notification-now' | translate"
                    (onClick)="updateNow()" />
                <p-button
                    type="button"
                    [label]="'sw-update-notification-later' | translate"
                    severity="secondary"
                    (onClick)="dismissNotification()" />
            </div>
        </div>
    </div>
}
